//@ts-check

// External
import React from "react"
import { useTranslation } from "react-i18next"
import useStyles from "./enter-eth-address.styles"
import Link from "@material-ui/core/Link"
import classnames from "classnames"
import clsx from "clsx"
import useIsWide from "src/utils/use-is-wide"

// Internal
import { Select } from "../select"
import { Input } from "../input"
import ConfirmExtractCode from "./confirm-extract-code"
const topTokens = require("../../utils/top-tokens")

export default function ChooseToken({
  onChangeToken,
  chosenToken,
  inputAddress,
  onExtractFromMainnet,
  mainnetRequestState,
  loadingSolidityState,
  isAutoSubmit,
  isInPopover,
}) {
  const { t } = useTranslation()
  const classes = useStyles({})
  var isWide = useIsWide()
  return (
    <div>
      <div style={{ 
        marginTop: 16, 
        display: "flex",
        flexDirection: isWide ? "row" : "column",
        justifyContent: "space-between",
     }}>
        <div
          style={{
            display: isWide ? "inline-block" : "block",
          }}
          className={clsx({
            [classes.tokenSelectWrapper]: isWide,
            [classes.tokenSelectWrapper_mobile]: !isWide,
          })}
        >
          <Select
            label={t("CHOOSE_ERC20_TOKEN")}
            onChange={onChangeToken}
            value={chosenToken}
            labelBackground={isInPopover ? "#ffffff" : "#f6f6fa"}
            width={"100%"}
            size="small"
          >
            <option key="" value="" />
            {topTokens.map(option => (
              <option key={option.token} value={JSON.stringify(option)}>
                {option.name}
              </option>
            ))}
          </Select>
        </div>
        {!isAutoSubmit && <ConfirmExtractCode
          inputAddress={inputAddress}
          loadingSolidityState={loadingSolidityState}
          onExtractFromMainnet={onExtractFromMainnet}
          mainnetRequestState={mainnetRequestState}
        />}
      </div>
      {chosenToken && <div className={clsx({
        [classes.poweredByNotice]: isWide,
        [classes.poweredByNotice_mobile]: !isWide,
      })}>        
        <p>{t("address")}: {inputAddress}</p>
      </div>}
      <div className={clsx({
        [classes.poweredByNotice]: isWide,
        [classes.poweredByNotice_mobile]: !isWide,
      })}>
        {/*
          // @ts-ignore */}
        <Link
          to="http://etherscan.io"
          target="_blank"
          rel="noopener"
          className={classes.sourceText}
        >
          {t("source")}
        </Link>
        <div
          className={classnames([
            classes.dateListCreatedText,
            classes.sourceText,
          ])}
        >
          {t("date_list_created")}
        </div>
      </div>
    </div>
  )
}
